import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

export default function EditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [newImage, setNewImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("sellerToken");

  /* ---------------- FETCH PRODUCT ---------------- */
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await axios.get(
          `https://haaterkaj-backend-1.onrender.com/api/seller/product/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.success) {
          setProduct(res.data.product);
        }
      } catch (err) {
        console.error("Error fetching product:", err);
        alert("Failed to load product");
      }
    };

    fetchProduct();
  }, [id, token]);

  /* ---------------- UPDATE PRODUCT ---------------- */
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!product) return;

    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("name", product.name || "");
      formData.append("description", product.description || "");
      formData.append("place", product.place || "");
      formData.append("price", product.price || "");
      formData.append(
        "features",
        Array.isArray(product.features)
          ? product.features.join(",")
          : ""
      );

      if (newImage) {
        formData.append("image", newImage);
      }

      const res = await axios.put(
        `https://haaterkaj-backend-1.onrender.com/api/seller/update/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // ❌ DO NOT SET Content-Type
          },
        }
      );

      if (res.data.success) {
        alert("Product updated successfully");
        navigate("/seller/dashboard");
      } else {
        alert(res.data.message || "Update failed");
      }
    } catch (err) {
      console.error("Update error:", err);
      alert("Failed to update product");
    } finally {
      setLoading(false);
    }
  };

  if (!product) {
    return <div className="p-6 text-center">Loading...</div>;
  }

  /* ---------------- UI ---------------- */
  return (
    <div className="max-w-md mx-auto mt-10 bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4 text-amber-700">
        Edit Product
      </h2>

      <form onSubmit={handleUpdate}>
        <input
          type="text"
          value={product.name || ""}
          onChange={(e) =>
            setProduct({ ...product, name: e.target.value })
          }
          className="border p-2 w-full mb-3 rounded"
          placeholder="Product Name"
          required
        />

        <textarea
          value={product.description || ""}
          onChange={(e) =>
            setProduct({ ...product, description: e.target.value })
          }
          className="border p-2 w-full mb-3 rounded"
          placeholder="Description"
        />

        <input
          type="text"
          value={product.place || ""}
          onChange={(e) =>
            setProduct({ ...product, place: e.target.value })
          }
          className="border p-2 w-full mb-3 rounded"
          placeholder="Place"
        />

        <input
          type="number"
          value={product.price || ""}
          onChange={(e) =>
            setProduct({ ...product, price: e.target.value })
          }
          className="border p-2 w-full mb-3 rounded"
          placeholder="Price"
        />

        <input
          type="text"
          value={
            Array.isArray(product.features)
              ? product.features.join(", ")
              : ""
          }
          onChange={(e) =>
            setProduct({
              ...product,
              features: e.target.value
                .split(",")
                .map((f) => f.trim()),
            })
          }
          className="border p-2 w-full mb-3 rounded"
          placeholder="Features (comma separated)"
        />

        {/* CURRENT IMAGE */}
        {product.image && (
          <img
            src={`https://haaterkaj-backend-1.onrender.com${product.image}`}
            alt="Product"
            className="w-full h-40 object-cover rounded mb-3"
          />
        )}

        {/* IMAGE UPDATE */}
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setNewImage(e.target.files[0])}
          className="border p-2 w-full mb-4 rounded"
        />

        <button
          type="submit"
          disabled={loading}
          className={`w-full text-white px-4 py-2 rounded ${
            loading
              ? "bg-gray-400"
              : "bg-amber-600 hover:bg-amber-700"
          }`}
        >
          {loading ? "Updating..." : "Update Product"}
        </button>
      </form>
    </div>
  );
}
